import { TrendingDown, TrendingUp } from "lucide-react";
import { usePoll } from "@/hooks/usePoll";
import { get } from "@/lib/api";
import { fmt, fmtPct, slug } from "@/lib/format";

const List = ({ rows, kind, onOpen }) => (
  <div className="space-y-px">
    {rows.map((r, i) => (
      <button key={r.instrument_token} data-testid={`${kind}-item-${slug(r.tradingsymbol)}`} onClick={() => onOpen(r)}
        className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left transition-colors hover:bg-slate-800/50">
        <span className="w-4 font-mono text-[10px] text-slate-600">{i + 1}</span>
        <span className="flex-1 truncate font-mono text-xs text-slate-200">{r.tradingsymbol}</span>
        <span className="num text-xs text-slate-400">{fmt(r.ltp)}</span>
        <span className={`num w-16 rounded-full px-2 py-0.5 text-right text-[11px] font-semibold ${kind === "gainer" ? "bg-emerald-950/50 text-emerald-400" : "bg-rose-950/50 text-rose-400"}`}>
          {fmtPct(r.change_pct)}
        </span>
      </button>
    ))}
    {rows.length === 0 && <div className="py-3 text-center text-[11px] text-slate-600">None</div>}
  </div>
);

export const GainersLosers = ({ onOpen }) => {
  const { data } = usePoll(() => get("/gainers-losers", { n: 6 }), 3000, []);
  return (
    <section data-testid="gainers-losers-panel" className="rounded-md border border-slate-800 bg-[#111827] p-3">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-400">Gainers / Losers</h4>
        <span className="font-mono text-[10px] text-slate-600">universe {data?.with_data ?? "—"}/{data?.universe_size ?? "—"}</span>
      </div>
      <div className="mb-1 flex items-center gap-1 text-[10px] uppercase tracking-wider text-emerald-500"><TrendingUp className="h-3 w-3" /> Top gainers</div>
      <List rows={data?.gainers || []} kind="gainer" onOpen={onOpen} />
      <div className="mb-1 mt-3 flex items-center gap-1 text-[10px] uppercase tracking-wider text-rose-500"><TrendingDown className="h-3 w-3" /> Top losers</div>
      <List rows={data?.losers || []} kind="loser" onOpen={onOpen} />
    </section>
  );
};
